import type { JobFragment } from '@/lib/types/datocms/graphql/generated'
import clsx from 'clsx'
import CtaTransparent from './ui/cta/CtaTransparent'

export default function JobsSection({
	id,
	title,
	description,
	link,
	activeAccordion,
	handleAccordionClick,
}: Readonly<JobFragment> & {
	activeAccordion: string | null
	handleAccordionClick: (id: string) => void
}) {
	return (
		<>
			{title && (
				<button
					className={clsx(
						'relative text-left py-5 w-full',
						// Top Border Animation - Gray Background
						"before:content-[''] before:absolute before:inset-x-0 before:top-0 before:h-[3px] before:bg-gray-light before:rounded-full before:transition-transform before:duration-500 before:m-ease before:origin-top",
						activeAccordion === id
							? 'before:scale-y-100'
							: 'before:scale-y-[33%] hover:before:scale-y-100',
						// Animated Blue Bar
						"after:content-[''] after:absolute after:inset-x-0 after:top-0 after:h-[3px] after:bg-blue after:rounded-full after:transition-transform after:duration-500 after:m-ease after:scale-x-0 after:origin-left  after:z-10",
						activeAccordion === id && 'before:scale-x-100 after:scale-x-100'
					)}
					onClick={() => handleAccordionClick(id as string)}
				>
					<h3 className="heading-size-5">{title}</h3>
				</button>
			)}
			<div
				className={clsx(
					'grid overflow-hidden transition-all duration-300 ease-in-out',
					activeAccordion === id ? 'grid-rows-[1fr] pb-5' : 'grid-rows-[0fr]'
				)}
			>
				<div className="overflow-hidden flex flex-col gap-6">
					{description && <p className="text-blue-dark/80 text-lg leading-snug">{description}</p>}
					{link && <CtaTransparent cta={link} variant="tertiary" />}
				</div>
			</div>
		</>
	)
}
